import React from 'react'
import { Card, Form, Input, Button, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';



const TankForm = ({ initialValues, onSubmit, onDelete, index }) => {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
      form.setFieldsValue(initialValues);
    }, [form, initialValues]);

    const handleSubmit = async (values) => {
      setSubmitting(true);
      try {
        await onSubmit({ ...values, tank_id: initialValues.tank_id }, index);
      } finally {
        setSubmitting(false);
      }
    };

    return (
      <Card
        title={`Citerne ${index + 1}`}
        extra={
          <Popconfirm
            title="Êtes-vous sûr de vouloir supprimer cette citerne ?"
            onConfirm={() => onDelete(initialValues.tank_id)}
            okText="Oui"
            cancelText="Non"
          >
            <DeleteOutlined className='text-red-500 text-2xl hover:bg-red-100 p-2 rounded-full' />
          </Popconfirm>
        }
        className='w-80 bg-indigo-50 mb-4'
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item name="tank_description" label="Descriptif" rules={[{ required: true }]}>
            <Input.TextArea rows={4} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={submitting}>
              {initialValues.tank_id ? 'Mettre à jour' : 'Créer'}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    );
  };

export default TankForm